import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';
import { BlockPayment } from './BlockPayment';
import { SVG_alert } from '../elements/SVG';
import { PAYMENT_STATUS } from '../../helpers/constants';
import { getExpandedPaymentScreen } from '../../helpers/paymentMethods';

export const BlockSummaryPaymentCollapsed = ({ changeScreen }) => {

    const { mainReducer } = useContext( MainContext );
    const currentPaymentMethod = mainReducer.state.currentPaymentMethod;

    const changeScreenLocal = () => {
        changeScreen(getExpandedPaymentScreen(mainReducer.state));
    }
    return  <>  
                <div className="e__plns__opt__pay__wpr">
                    <div className="e__plns__opt__pay__info">
                        <BlockPayment payment={ mainReducer.state.currentPaymentMethod } />
                        <div className='e__plns__opt__pay__info__wrapper'>
                        {(currentPaymentMethod.status === PAYMENT_STATUS.PROCESSING) &&
                          <div>
                            <SVG_alert />
                            {getText('payment_method_pending')}
                        </div>  
                        }
                        <button className="e__lnk" onClick={ changeScreenLocal } >{ getText('cambiar') }</button>
                        </div>
                    </div>
                </div>
            </>;
}